// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__EWf19","containerItemsCenter":"Skeleton_containerItemsCenter__1lyTU"};